$(document).ready(function(){

  // -- init Masonry --
  var masonrySettings = {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    gutter: 0,
  };
  var $grid = $('.grid').imagesLoaded(function(){
    // -- init Masonry after all images have loaded --
    $grid.masonry(masonrySettings);
  });

});